import React from 'react';
import { Button } from '@itwin/itwinui-react';
import { t } from '../../../services/translation';
import { useWebViewLink } from './useWebViewLink';

type WebViewLinkProps = {
  cannedConnection?: boolean;
};

export function WebViewLink({
  cannedConnection
}: WebViewLinkProps): JSX.Element | null {
  const webViewLink = useWebViewLink(cannedConnection);

  function navigateLink(): void {
    window.location.href = webViewLink;
  }

  if (!webViewLink || cannedConnection) {
    return null;
  }

  return (
    <Button
      onClick={navigateLink}
      data-link={webViewLink}
      data-testid="projectwise-web-view-button"
    >
      {t('ProductName.ProjectWiseWebView')}
    </Button>
  );
}
